export const SECTIONS = ['chat', 'projects', 'tasks', 'crm', 'marketplace', 'settings', 'account', 'help'];
export const DEFAULT_SECTION = 'chat';

export const MARKETPLACE_TYPES = ['ozon', 'wildberries'];
export const DEFAULT_MARKETPLACE = 'ozon';

export function isWorkspacePath(pathname) {
  return pathname === '/' || pathname.startsWith('/app');
}

export function parseAppLocation(pathname, search) {
  const match = pathname.match(/^\/app\/([^/]+)(?:\/([^/]+))?/);
  let section = DEFAULT_SECTION;
  let marketplaceType = DEFAULT_MARKETPLACE;
  let openProjectId = '';

  if (match) {
    if (SECTIONS.includes(match[1])) section = match[1];
    if (match[2] && MARKETPLACE_TYPES.includes(match[2])) marketplaceType = match[2];
    // Открытая карточка проекта — часть пути: /app/projects/<id>; без id — список проектов.
    if (section === 'projects' && match[2]) openProjectId = match[2];
  }

  const params = new URLSearchParams(search);
  const tab = params.get('tab') || '';
  // Marketplace-scoped deep-link params (currently used by the Ozon section):
  // ?project=<workspaceId>&account=<marketplaceAccountId>&tool=<ozonTab>
  const project = params.get('project') || '';
  const account = params.get('account') || '';
  const tool = params.get('tool') || '';

  const sub = params.get('sub') || '';
  // Период (?from=&to=) и набор кампаний (?camp=id1,id2) — ссылки из уведомлений ведут на «ровно то, о чём предупредили».
  const from = params.get('from') || '';
  const to = params.get('to') || '';
  const camp = params.get('camp') || '';

  return { section, marketplaceType, openProjectId, tab, project, account, tool, sub, from, to, camp };
}

// `marketplaceParams` (optional) carries { project, account, tool, sub }. `project` — текущий проект —
// переносится в любой раздел; account/tool/sub — только в раздел Ozon.
// `openProjectId` (5-й аргумент) — открытая карточка проекта в разделе «Проекты».
// Подвкладки раздела «Задачи» (кроме основной): чужой sub (например, из Ozon) сюда не переносится.
const TASKS_SUBS = ['dynamics'];
const CRM_SUBS = ['deals', 'companies', 'contacts', 'settings'];

export function buildAppPath(section, marketplaceType, settingsTab, marketplaceParams, openProjectId) {
  const resolvedSection = SECTIONS.includes(section) ? section : DEFAULT_SECTION;
  const resolvedMarketplace = MARKETPLACE_TYPES.includes(marketplaceType) ? marketplaceType : DEFAULT_MARKETPLACE;
  let path = `/app/${resolvedSection}`;
  if (resolvedSection === 'marketplace') {
    path += `/${resolvedMarketplace}`;
  }
  if (resolvedSection === 'projects' && openProjectId) {
    path += `/${openProjectId}`;
  }

  const query = new URLSearchParams();
  if (resolvedSection === 'settings' && settingsTab) {
    query.set('tab', settingsTab);
  }
  if (marketplaceParams?.project) query.set('project', marketplaceParams.project);
  if (resolvedSection === 'marketplace' && resolvedMarketplace === 'ozon' && marketplaceParams) {
    const { account, tool, sub, from, to, camp } = marketplaceParams;
    if (account) query.set('account', account);
    if (tool) query.set('tool', tool);
    if (sub) query.set('sub', sub);
    if (from) query.set('from', from);
    if (to) query.set('to', to);
    if (camp) query.set('camp', camp);
  }
  // Вкладка раздела «Задачи» (Задачи/Динамика) тоже живёт в адресе.
  if (resolvedSection === 'tasks') {
    if (TASKS_SUBS.includes(marketplaceParams?.sub)) query.set('sub', marketplaceParams.sub);
    // Фильтры задач (tf — JSON только заполненных полей) и вид списка (view) тоже в адресе.
    if (marketplaceParams?.tf) query.set('tf', marketplaceParams.tf);
    if (['list', 'kanban'].includes(marketplaceParams?.view) && marketplaceParams.view !== 'list') query.set('view', marketplaceParams.view);
  }
  if (resolvedSection === 'crm' && CRM_SUBS.includes(marketplaceParams?.sub)) query.set('sub', marketplaceParams.sub);
  const qs = query.toString();
  if (qs) path += `?${qs}`;
  return path;
}
